import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  data: any
}

const mutateAddNote = async ({projectId, taskId, data}: mutateProps) => {
  return await axiosAuth.post(`${PROJECT_API}/${projectId}/tasks/${taskId}/notes`, data);
};

const useAddNoteMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateAddNote,
    ...queryParams,
  });

export default useAddNoteMutation;
